export default {
  common: {
    notification: 'اعلانات',
    pushNotification: 'اعلانات زنده',
    markAllAsRead: 'علامت‌گذاری همه به عنوان خوانده شده',
    clearAll: 'پاک کردن همه',
    noNotifications: 'هیچ اعلانی وجود ندارد',
    remove: 'حذف',
    filterAll: 'همه',
    filterPayments: 'پرداخت‌ها',
    filterInvoices: 'بل‌ها',
    filterUnread: 'خوانده نشده',
    clickToSearch: 'کلیک جهت جستجو در بلینگ',
  },
  tip: {
    unreadNotification: 'شما {count} اعلان خوانده نشده دارید',
    pushNotification: 'نمایش تغییرات لحظه‌ای پرداخت‌ها و بل‌ها',
  },
};
